import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'app-transaction-failed',
    templateUrl: './transaction-failed.component.html',
    styleUrls: ['./transaction-failed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslatePipe,
    ]
})
export class TransactionFailedComponent {
}
